export const companyConfig = {
  name: "FUM DA Handels GmbH",
  fullName: "FUM DA Handels GmbH",
  location: "Wöhlerstraße 8, 22113 Hamburg",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=W%C3%B6hlerstr.+8,+22113+Hamburg,+Deutschland",
  emails: ["info@fumda.de", "chen@fumda.de", "sanchez@fumda.de"],
  phone: "+49 40 7310510",
  website: "https://fumda.de"
};
